import {
  ConsentStatus,
  UNLEASH_FEATURE_NAME,
  type InitialState
} from '@schibsted-nmp/advertising-shared';
import { Script } from '@client/core/utils/Script.js';

export namespace Scripts {
  export function* get(
    initialState: InitialState
  ): Generator<Script, void, void> {
    if (!isEnabled(initialState)) return;

    yield {
      name: 'adn',
      src: 'https://cdn.adnuntius.com/adn.js',
      defer: true
    };
  }

  export function getServerHtml(initialState: InitialState) {
    if (!isEnabled(initialState)) return '';

    return Array.from(
      Script.getServerHtml(
        initialState,
        get,
        `<script>(()=>{(window.adn??={}).calls??=[]})();</script>`
      )
    ).join('\n');
  }

  export function isEnabled({ unleashFeatures, config }: InitialState) {
    if (!unleashFeatures[UNLEASH_FEATURE_NAME.enableAdnuntius]?.enabled) {
      return false;
    }

    if (!config.adServer.adn) return false;

    // Adnuntius is only enabled for non-consented users:
    return config.consent === ConsentStatus.Rejected;
  }
}
